import EmptyStateBox from './component'
export default EmptyStateBox
